/** Deutsche Texte des Auto-Designers. */
export const deCar = {
  sections: {
    car: {
      model: 'Modell',
      engine: 'Motor',
      trim: 'Ausstattung',
      drivetrain: 'Antrieb',
      suspension: 'Fahrwerk',
      wheels: 'Räder',
      brakes: 'Bremsen',
      aero: 'Aerodynamik',
      paint: 'Lack',
    },
  },
  params: {
    car: {
      shape: 'Grundform',
      length: 'Länge',
      width: 'Breite',
      height: 'Höhe',
      wheelbase: 'Radstand',
      overhangFront: 'Überhang vorn',
      trackFront: 'Spurweite vorn (Anteil der Breite)',
      trackRear: 'Spurweite hinten (Anteil der Breite)',
      noseHeight: 'Nasenhöhe',
      hoodHeight: 'Haubenhöhe',
      windshieldRake: 'Scheibenneigung',
      roofLength: 'Dachlänge',
      rearSlope: 'Heckneigung (Fließheck)',
      deckHeight: 'Heckdeckelhöhe',
      beltline: 'Gürtellinie',
      tumblehome: 'Dacheinzug',
      frontTaper: 'Verjüngung vorn',
      rearTaper: 'Verjüngung hinten',
      archFlare: 'Kotflügelverbreiterung',
      chassis: 'Chassis-Bauart',
      chassisMaterial: 'Chassis-Werkstoff',
      frontSuspension: 'Aufhängung vorn',
      rearSuspension: 'Aufhängung hinten',
      quality: 'Qualität',
      placement: 'Einbaulage',
      bodyMaterial: 'Karosserie-Werkstoff',
      interior: 'Innenraum',
      seats: 'Sitzplätze',
      entertainment: 'Unterhaltung',
      safety: 'Sicherheitsausstattung',
      powerSteering: 'Servolenkung',
      abs: 'ABS',
      tcs: 'Traktionskontrolle',
      esc: 'Stabilitätskontrolle (ESP)',
      launchControl: 'Launch Control',
      layout: 'Antriebsart',
      awdFrontShare: 'Momentenanteil vorn',
      gearbox: 'Getriebe',
      gears: 'Gänge',
      ratio: 'Gang',
      cvtLow: 'Größte Übersetzung',
      cvtHigh: 'Kleinste Übersetzung',
      finalDrive: 'Achsübersetzung',
      differential: 'Differenzial',
      springs: 'Federn',
      dampers: 'Dämpfer',
      antiRoll: 'Stabilisatoren',
      rideHeight: 'Bodenfreiheit',
      springStiffness: 'Federhärte',
      damping: 'Dämpfung',
      antiRollBar: 'Stabilisator',
      camber: 'Sturz',
      tireType: 'Reifentyp',
      rimDiameter: 'Felgendurchmesser',
      rimMaterial: 'Felgen-Werkstoff',
      rimDesign: 'Felgendesign',
      aspectRatio: 'Querschnitt (Flankenhöhe)',
      pads: 'Bremsbeläge',
      bias: 'Bremskraftverteilung vorn',
      type: 'Bauart',
      diameter: 'Durchmesser',
      pistons: 'Kolben pro Sattel',
      frontDownforce: 'Abtrieb vorn (Splitter)',
      rearDownforce: 'Abtrieb hinten (Flügel)',
      undertray: 'Unterboden',
      cooling: 'Kühlluftöffnungen',
      color: 'Farbe',
      finish: 'Lackart',
      flake: 'Effektpigmente',
      pearlColor: 'Farbflop',
      clearcoat: 'Klarlack',
    },
  },
  options: {
    bodyMaterial: {
      steel: 'Stahl',
      'galvanised-steel': 'Stahl verzinkt',
      aluminium: 'Aluminium',
      fibreglass: 'GFK',
      cfrp: 'CFK (Carbon)',
    },
    suspensionType: {
      'solid-axle': 'Starrachse',
      macpherson: 'McPherson',
      'double-wishbone': 'Doppelquerlenker',
      pushrod: 'Pushrod',
      'torsion-beam': 'Verbundlenker',
      'semi-trailing': 'Schräglenker',
      'multi-link': 'Mehrlenker',
    },
    paintZone: {
      roof: 'Dach abgesetzt',
      hood: 'Haube abgesetzt',
      lower: 'Schweller/Stoßfänger abgesetzt',
    },
    params: {
      car: {
        shape: {
          coupe: 'Coupé',
          sedan: 'Limousine',
          wagon: 'Kombi',
          hatchback: 'Schrägheck',
          suv: 'SUV',
          roadster: 'Roadster',
          pickup: 'Pickup',
          van: 'Van',
        },
        chassis: {
          monocoque: 'Selbsttragend',
          ladder: 'Leiterrahmen',
          spaceframe: 'Gitterrohrrahmen',
        },
        placement: {
          'front-longitudinal': 'Front längs',
          'front-transverse': 'Front quer',
          'mid-longitudinal': 'Mitte längs',
          'mid-transverse': 'Mitte quer',
          'rear-longitudinal': 'Heck',
        },
        interior: {
          basic: 'Einfach',
          standard: 'Standard',
          premium: 'Premium',
          luxury: 'Luxus',
          sport: 'Sport',
          race: 'Rennsport',
        },
        entertainment: {
          none: 'Keine',
          radio: 'Radio',
          infotainment: 'Infotainment',
          'premium-infotainment': 'Premium-Infotainment',
        },
        safety: { basic: 'Einfach', standard: 'Standard', advanced: 'Erweitert', modern: 'Modern' },
        powerSteering: { none: 'Keine', hydraulic: 'Hydraulisch', electric: 'Elektrisch' },
        layout: { fwd: 'Frontantrieb', rwd: 'Heckantrieb', awd: 'Allrad' },
        gearbox: {
          manual: 'Schaltgetriebe',
          automatic: 'Wandlerautomatik',
          dct: 'Doppelkupplung',
          sequential: 'Sequenziell',
          cvt: 'Stufenlos (CVT)',
        },
        differential: {
          open: 'Offen',
          viscous: 'Visco-Sperre',
          'plate-lsd': 'Lamellensperre',
          torsen: 'Torsen',
          active: 'Aktiv (Torque Vectoring)',
        },
        springs: {
          passive: 'Stahlfedern',
          progressive: 'Progressiv',
          hydropneumatic: 'Hydropneumatisch',
          air: 'Luftfederung',
        },
        dampers: { 'twin-tube': 'Zweirohr', 'mono-tube': 'Einrohr', adaptive: 'Adaptiv' },
        antiRoll: { none: 'Keine', passive: 'Passiv', active: 'Aktiv' },
        tireType: {
          eco: 'Spar',
          touring: 'Komfort',
          sport: 'Sport',
          'semi-slick': 'Semislick',
          slick: 'Slick',
          'all-terrain': 'All-Terrain',
          offroad: 'Offroad',
        },
        rimMaterial: {
          steel: 'Stahl',
          alloy: 'Alu-Guss',
          forged: 'Alu geschmiedet',
          magnesium: 'Magnesium',
          cfrp: 'Carbon',
        },
        rimDesign: {
          steel: 'Stahlfelge',
          'five-spoke': 'Fünfspeichen',
          'multi-spoke': 'Vielspeichen',
          mesh: 'Kreuzspeichen',
          aero: 'Aero-Scheibe',
        },
        pads: {
          organic: 'Organisch',
          'semi-metallic': 'Teilmetallisch',
          ceramic: 'Keramik',
          race: 'Rennsport',
        },
        type: {
          drum: 'Trommel',
          'solid-disc': 'Scheibe',
          'vented-disc': 'Scheibe innenbelüftet',
          'carbon-ceramic': 'Carbon-Keramik',
        },
        undertray: { none: 'Offen', partial: 'Teilverkleidet', full: 'Vollverkleidet' },
        finish: {
          solid: 'Uni',
          metallic: 'Metallic',
          pearl: 'Perleffekt',
          matte: 'Matt',
          satin: 'Seidenmatt',
          chrome: 'Chrom',
        },
      },
    },
  },
  help: {
    params: {
      car: {
        shape: 'Grundform der Karosserie. Bestimmt Dachlinie, Heck und Grund-cw-Wert.',
        wheelbase: 'Abstand der Achsen. Lang = ruhiger Geradeauslauf und Platz, kurz = wendig.',
        chassis:
          'Selbsttragend ist leicht und steif, Leiterrahmen robust und schwer (Nutzwert, Offroad), Gitterrohr leicht, aber teuer.',
        placement: 'Mittelmotor gibt eine ausgewogene Gewichtsverteilung, Frontquer spart Platz.',
        bodyMaterial: 'Aluminium und Carbon sparen viel Gewicht, kosten aber deutlich mehr.',
        layout:
          'Heck- und Allradantrieb übertragen mehr Leistung beim Beschleunigen; Front ist leicht und günstig.',
        gearbox:
          'Doppelkupplung schaltet am schnellsten, Automatik am bequemsten, Schaltgetriebe ist leicht und günstig.',
        finalDrive:
          'Höhere Achsübersetzung beschleunigt besser, senkt aber die Höchstgeschwindigkeit.',
        differential: 'Sperren verteilen das Moment besser auf beide Räder: bessere Traktion.',
        rideHeight:
          'Tiefer senkt Schwerpunkt und Luftwiderstand, höher bringt Komfort und Geländegängigkeit.',
        springStiffness: 'Harte Federn verbessern das Handling, weiche den Komfort.',
        camber: 'Leicht negativer Sturz (≈ −1,5°) verbessert den Kurvengrip.',
        tireType:
          'Weichere Mischungen haften besser, rollen aber schwerer und verschleißen schneller.',
        bias: 'Anteil der Bremskraft vorn. Ideal ist er etwas höher als die Gewichtsverteilung, weil sich beim Bremsen Last nach vorn verlagert.',
        rearDownforce:
          'Heckflügel erhöhen den Grip in schnellen Kurven, kosten aber Höchstgeschwindigkeit.',
        cooling:
          'Mehr Kühlluft verhindert Überhitzung starker Motoren, erhöht aber den Luftwiderstand.',
        quality: 'Höhere Qualität verbessert Zuverlässigkeit und Wertigkeit, kostet aber mehr.',
      },
    },
  },
  formula: {
    params: {
      car: {
        finalDrive: 'F_Rad = M · i_G · i_A · η / r',
        rideHeight: 'F_W = ½ ρ c_w A v² + f_R (1 + V/160) (m g + F_Abtrieb)',
        bias: 'Optimum ≈ Achslast vorn + μ · h_S / l',
      },
    },
  },
  stats: {
    car: {
      power: 'Leistung',
      mass: 'Leergewicht',
      accel: 'Beschleunigung',
      topSpeed: 'Höchstgeschwindigkeit',
      braking: 'Bremsweg',
      lateral: 'Querbeschleunigung',
      consumption: 'Verbrauch',
      cost: 'Herstellkosten',
      running: 'Unterhalt {value}/Jahr',
      powerToMass: 'Leistungsgewicht',
      drag: 'cw · A',
      quarterMile: 'Viertelmeile',
      elasticity: 'Durchzug',
      range: 'Reichweite',
    },
  },
  charts: {
    traction: 'Zugkraft je Gang und Fahrwiderstand (kN)',
    resistance: 'Fahrwiderstand',
  },
  ratings: {
    car: {
      drivability: 'Fahrbarkeit',
      sportiness: 'Sportlichkeit',
      comfort: 'Komfort',
      safety: 'Sicherheit',
      practicality: 'Praktikabilität',
      utility: 'Nutzwert',
      offroad: 'Offroad',
      reliability: 'Zuverlässigkeit',
      prestige: 'Prestige',
    },
  },
  warnings: {
    car: {
      engineTooLong: {
        text: 'Der Motor ist zu lang für den Motorraum.',
        fix: 'Vorderen Überhang verlängern, kürzeren Motor wählen oder Einbaulage ändern.',
      },
      engineTooWide: {
        text: 'Der Motor ist zu breit für den Motorraum.',
        fix: 'Breiteres Auto, schmalere Reifen oder einen Reihenmotor wählen.',
      },
      engineTooLongTransverse: {
        text: 'Quer passt der Motor nicht zwischen die Räder.',
        fix: 'Längs einbauen, Auto verbreitern oder weniger Zylinder wählen.',
      },
      engineNoRoomMid: {
        text: 'Hinter den Sitzen ist zu wenig Platz für den Motor.',
        fix: 'Radstand verlängern oder Motor vorn einbauen.',
      },
      engineTooTall: {
        text: 'Der Motor ragt über die Motorhaube.',
        fix: 'Haube höher setzen, Bodenfreiheit senken oder flacheren Motor wählen.',
      },
      roadsterSeats: {
        text: 'Ein Roadster hat höchstens zwei Sitze.',
        fix: 'Sitzplätze reduzieren oder andere Grundform wählen.',
      },
      tooManySeats: {
        text: 'So viele Sitze passen nur in Van, SUV oder Kombi.',
        fix: 'Grundform ändern oder Sitze reduzieren.',
      },
      gearboxTorque: {
        text: 'Das Getriebe ist dem Drehmoment nicht gewachsen.',
        fix: 'Sequenzielles Getriebe oder Automatik wählen, Qualität erhöhen oder Motor zahmer abstimmen.',
      },
      firstGearTall: {
        text: 'Der erste Gang ist zu lang zum Anfahren.',
        fix: 'Erste Übersetzung oder Achsübersetzung erhöhen.',
      },
      topGearShort: {
        text: 'Die Höchstgeschwindigkeit wird vom Drehzahlbegrenzer begrenzt.',
        fix: 'Längere Achsübersetzung oder längeren letzten Gang wählen.',
      },
      fwdTooMuchPower: {
        text: 'Viel Leistung für Frontantrieb.',
        fix: 'Allrad oder Heckantrieb, Lamellensperre oder breitere Reifen helfen.',
      },
      noTraction: {
        text: 'Sehr viel Leistung ohne Traktionskontrolle.',
        fix: 'Traktionskontrolle aktivieren oder Allrad wählen.',
      },
      brakesWeak: {
        text: 'Die Bremsen sind zu schwach.',
        fix: 'Größere Scheiben, mehr Kolben oder bessere Beläge verbauen.',
      },
      overheating: { text: 'Der Motor droht zu überhitzen.', fix: 'Kühlluftöffnungen vergrößern.' },
      brakeRimClearance: {
        text: 'Die Bremsscheibe passt nicht in die Felge.',
        fix: 'Größere Felgen oder kleinere Bremsscheiben wählen.',
      },
      tireTooWide: {
        text: 'Die Reifen sind zu breit für die Radhäuser.',
        fix: 'Kotflügel verbreitern oder schmalere Reifen wählen.',
      },
      weightDistribution: {
        text: 'Ungewöhnliche Gewichtsverteilung.',
        fix: 'Motorlage ändern oder Radstand anpassen.',
      },
      understeer: {
        text: 'Das Auto untersteuert stark.',
        fix: 'Stabilisator vorn weicher, hinten härter oder breitere Vorderreifen.',
      },
      oversteer: {
        text: 'Das Auto übersteuert stark.',
        fix: 'Stabilisator hinten weicher, vorn härter oder breitere Hinterreifen.',
      },
      cabinIntrusion: {
        text: 'Der Motor ragt in den Innenraum.',
        fix: 'Radstand verlängern oder Motor weiter vorn einbauen.',
      },
    },
  },
  massGroups: {
    chassis: 'Rohkarosserie',
    body: 'Außenhaut',
    glass: 'Verglasung',
    engine: 'Motor',
    drivetrain: 'Antriebsstrang',
    suspension: 'Fahrwerk',
    wheels: 'Räder',
    brakes: 'Bremsen',
    interior: 'Innenraum',
    equipment: 'Ausstattung',
    fuel: 'Kraftstoff',
    exhaust: 'Abgasanlage',
    cooling: 'Kühlung',
    electrical: 'Elektrik',
    aero: 'Aero-Teile',
    misc: 'Sonstiges',
  },
  designer: {
    view: 'Ansicht',
    views: { normal: 'Normal', xray: 'Röntgen', exploded: 'Explosion' },
    shape: 'Form',
    chassis: 'Chassis',
    front: 'Vorn',
    rear: 'Hinten',
    zones: 'Mehrfarbig',
    wrap: 'Folierung',
    wrapEnabled: 'Folie statt Lack',
    embeddedEngine: 'Eingebauter Motor',
    editEngine: 'Motor bearbeiten',
    updateEngine: 'Auf neuen Stand aktualisieren',
    chooseEngine: 'Motor wählen',
    adoptEngine: 'In Motor-Bibliothek übernehmen',
    engineOf: 'Motor von {name}',
    engineSummary: '{layout}, {cylinders} Zyl. · {liters} l',
    massBreakdown: 'Massenbilanz',
  },
};
